var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('div',{staticClass:"content"},_vm._l((_vm.indexList),function(item,index){return _c('IndexTemplate',{key:index,attrs:{"block":item,"py":index}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }